import axios from '@/plugin/axios';

const endpoint = '/contact-us/';

export const getContacts = (url = endpoint) => axios.get(url);
export const createContact = (payload) => axios.post(endpoint, payload);
export const updateContact = (id, payload) =>
  axios.put(`${endpoint}${encodeURIComponent(id)}/`, payload);
export const deleteContact = (id) => axios.delete(`${endpoint}${encodeURIComponent(id)}/`);
